module.exports = __webpack_public_path__ + "static/media/logo.bfec4349.png";